<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="'change-requests.editRequestTemplate'" [back]="true"></app-header>

    <app-steps
        #appSteps
        [steps]="[requestTemplateStep, requestersAndApproversStep, reviewStep]"
        (onPrimary)="onSave()"
        [labels]="{ primary: 'save' }"
    >
        <app-step
            #requestTemplateStep
            [stepForm]="changeRequestTemplateForm"
            step="{{ 'change-requests.requestTemplate' | translate }}"
        >
            <app-change-request-template-form
                #changeRequestTemplateForm
                [changeRequestTemplate]="changeRequestTemplate"
            ></app-change-request-template-form>
        </app-step>

        <app-step
            [embeddedCard]="false"
            #requestersAndApproversStep
            [stepForm]="requestersAndApproversForm"
            step="{{ 'change-requests.requestersAndApprovers' | translate }}"
        >
            <app-requesters-and-approvers-form
                #requestersAndApproversForm
                [approvalWorkflow]="approvalWorkflow"
                [changeRequestTemplate]="changeRequestTemplate"
                [selectedRoleIds]="selectedRoleIds"
                [selectedRoleNames]="selectedRoleNames"
                [roles]="roles"
                [notifySubject]="changeRequestTemplate.notifySubject"
                (rolesChanged)="updateRoles($event)"
                (notifySubjectChanged)="handleNotifySubjectChanged($event)"
            ></app-requesters-and-approvers-form>
        </app-step>

        <app-step
            #reviewStep
            [stepForm]="requestTemplateReviewForm"
            step="{{ 'change-requests.review' | translate }}"
            [embeddedCard]="false"
        >
            <app-request-template-review-form
                #requestTemplateReviewForm
                [changeRequestTemplate]="changeRequestTemplate"
                [selectedRoleNames]="selectedRoleNames"
                [notifySubject]="notifySubject"
                [approvalWorkflow]="approvalWorkflow"
            ></app-request-template-review-form>
        </app-step>
    </app-steps>
</div>
